import { SchemeTokenType } from '../enums/scheme-token-type.enum';
import { TokenRequestorIdType } from '../enums/token-requestor-id-type.enum';
import { ISchemeTokenRequestorId } from './scheme-token-requestor-id.interface';

export interface ISchemeToken {
  schemeTokenType?: SchemeTokenType;
  schemeTokenRequestorType?: TokenRequestorIdType;
  schemeTokenRequestIds?: ISchemeTokenRequestorId[];
}
